import React, { useEffect, useState } from "react";
import { alpha, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { theme } from "../../../../constants";
import { Trade } from "../../../../types/models/Trade";
import { POSITION_TYPE } from "../../../../constants/constants";
import { ArrowDownIcon, ArrowUpIcon } from "../../../../constants/icons";
import { fullTime, localeDate } from "../../../../utils/dateUtils";
import TimerWidget from "../../../../components/shared/TimerWidget";

interface MyTradeDetailProps {
  item: Trade;
  active: boolean;
}

const MyTradeDetail: React.FC<MyTradeDetailProps> = ({ item, active }) => {
  console.log("item", item);

  const { t, i18n } = useTranslation();
  const closeTimeDate: Date = new Date(item.closingTime);
  const timestamp = closeTimeDate.getTime();
  const [activeTrade, setActiveTrade] = useState<boolean>(active);

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date().getTime();
      if (timestamp < now) {
        setActiveTrade(false); // Ensure activeTrade is updated when timestamp is in the past
        clearInterval(interval); // Clear the interval when the condition is met
      }
    }, 1000);

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [timestamp]);

  const renderPosition = (positionType: string) => {
    if (positionType === POSITION_TYPE.UP) {
      return (
        <div style={{ display: "flex" }}>
          <span>{t("up")}</span>
          <ArrowUpIcon color="green" size={20} />
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex" }}>
          <span>{t("down")}</span>
          <ArrowDownIcon color="red" size={20} />
        </div>
      );
    }
  };

  return (
    <div
      className="my-trades_detail"
      style={{ background: alpha(theme.colors.secondaryTextColor, 0.2) }}
    >
      <Grid container>
        <Grid xs={6}>
          <div style={{ marginBottom: 10 }}>
            <Typography variant="body2" color={theme.colors.darkGrey}>
              {t("investment")}
            </Typography>
            <Typography variant="body1" color="white">
              {item?.investment}$
            </Typography>
          </div>
          <div style={{ marginBottom: 10 }}>
            <Typography variant="body2" color={theme.colors.darkGrey}>
              {t("statusType")}
            </Typography>
            <Typography variant="body1" color="white">
              {renderPosition(item?.positionType ?? "")}
            </Typography>
          </div>
          <div style={{ marginBottom: 10 }}>
            <div style={{ marginBottom: 10 }}>
              <Typography variant="body2" color={theme.colors.darkGrey}>
                {t("openingTime")}
              </Typography>
              <Typography variant="body1" color="white">
                {localeDate(item?.openingTime ?? new Date(), i18n.language)},{" "}
                {fullTime(item?.openingTime ?? new Date())}
              </Typography>
            </div>
            <Typography variant="body2" color={theme.colors.darkGrey}>
              {t("closingTime")}
            </Typography>
            <Typography variant="body1" color="white">
              {localeDate(item?.closingTime ?? new Date(), i18n.language)},{" "}
              {fullTime(item?.closingTime ?? new Date())}
            </Typography>
          </div>
          <div style={{ marginBottom: 10 }}>
            <Typography variant="body2" color={theme.colors.darkGrey}>
              {t("expiringTime")}
            </Typography>
            <Typography variant="body1" color="white">
              {localeDate(item?.closingTime ?? new Date(), i18n.language)},{" "}
              {fullTime(item?.closingTime ?? new Date())}
            </Typography>
          </div>
        </Grid>
        <Grid xs={6}>
          <div style={{ marginBottom: 10 }}>
            <Typography variant="body2" color={theme.colors.darkGrey}>
              {t("return")}
            </Typography>
            <div style={{ display: "flex" }}>
              <Typography variant="body1" color="white" sx={{ mr: 1 }}>
                ${item?.return?.amount?.toFixed(2) ?? 0}
              </Typography>
              <Typography variant="body1" color="white">
                {item?.return?.percent ?? 0}%
              </Typography>
            </div>
          </div>
          <div style={{ marginBottom: 10 }}>
            <Typography variant="body2" color={theme.colors.darkGrey}>
              {t("positionId")}
            </Typography>
            <Typography variant="body1" color="white">
              {item?.positionId}
            </Typography>
          </div>
          <div style={{ marginBottom: 10 }}>
            <Typography variant="body2" color={theme.colors.darkGrey}>
              {t("openingPrice")}
            </Typography>
            <Typography variant="body1" color="white">
              {item?.openingPrice}
            </Typography>
          </div>
          <div style={{ marginBottom: 10 }}>
            <Typography variant="body2" color={theme.colors.darkGrey}>
              {t("closingPrice")}
            </Typography>
            <Typography variant="body1" color="white">
              {item?.closingPrice}
            </Typography>
          </div>
          <div style={{ marginBottom: 10 }}>
            {activeTrade === true ? (
              <TimerWidget
                value={timestamp}
                timerRange={item?.assetTimer.timer.timerRange}
              />
            ) : (
              <>
                <Typography variant="body2" color={theme.colors.darkGrey}>
                  {t("closingMethod")}
                </Typography>
                <Typography variant="body1" color="white">
                  {item?.closingMethod ?? t("expired")}
                </Typography>
              </>
            )}
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default MyTradeDetail;
